<div #container class="nc-prismatic-burst-canvas-container"></div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>
